import React from "react";
import PropTypes from "prop-types";
import SFIconButton from "./iconButton";
import { SFDownloadIcon } from "../icons";
import { exportAsImage } from "../../helpers/exportAsImage";

const SFExportAsImageBtn = ({
  exportRef,
  imageName,
  isModalOpen,
  alignItems,
  disabled,
  variant
}) => {
  const clickDownloadHandler = () => {
    exportAsImage(exportRef, imageName, isModalOpen, alignItems);
  };
  return (
    <SFIconButton
      type="button"
      onClick={clickDownloadHandler}
      disabled={disabled}
      {...variant && ({variant})}
    >
      <SFDownloadIcon color="primary" />
    </SFIconButton>
  );
};

SFExportAsImageBtn.propTypes = {
  /* The element ref to be exported  */
  exportRef: PropTypes.any,
  /* The name of the image file  */
  imageName: PropTypes.string,
  /* Flag that exports image from a modal */
  isModalOpen: PropTypes.bool,
  alignItems: PropTypes.oneOf(["flex-start", "center", "flex-end"]),
  disabled: PropTypes.bool,
  variant: SFIconButton.propTypes.variant
};

export default SFExportAsImageBtn;
